// extracted by mini-css-extract-plugin
module.exports = {"title":"_422_title_1-72P"};